import { create } from "zustand";
import { persist } from "zustand/middleware";
import { normalizeCurrency, DEFAULT_CURRENCY, type CurrencyCode } from "@lib/i18n/languages";
import { OWNER_CURRENCY_LS_KEY } from "@lib/ownerPersistKeys";

interface CurrencyStore {
    currency: CurrencyCode;
    setCurrency: (code: unknown) => void;
}

export const useCurrencyStore = create<CurrencyStore>()(
    persist(
        (set) => ({
            currency: DEFAULT_CURRENCY,
            setCurrency: (code) => set({ currency: normalizeCurrency(code) }),
        }),
        { name: OWNER_CURRENCY_LS_KEY, partialize: (s) => ({ currency: s.currency }) }
    )
);

export function getCurrentCurrency(): CurrencyCode {
    return useCurrencyStore.getState().currency;
}
